import { Modal } from "antd";
import React, { useState } from "react";
import FrasesRequest from "../../FrasesRequest";
import { ModalStatusDelete } from "../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, estadoFrase }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deleteFrase = async () => {
    setConfirmLoading(true);
    try {
      const response = await FrasesRequest.ExcluirFrases(id);
      if (response.status === 204) {
        onCancel();
        estadoFrase((prevState) => prevState.filter((item) => item.id !== id));
        setConfirmLoading(false);
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deleteFrase}
        confirmLoading={confirmLoading}
      >
        <text style={{ fontSize: 16, fontWeight: "500" }}>
          Deseja realmente excluir esta Frase?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
